import { ca } from '@cian/analytics';

export const trackMortgageBannerClick = () => {
  ca('eventSite', {
    ec: 'CB',
    ea: 'Click',
    el: 'Mortgage_banner_CB',
  });
};
